import { HttpInterceptorFn, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { MessageService } from "@core/services/message.service";
import { SpinnerService } from "@core/services/spinner.service";
import { Observable, finalize, catchError, throwError } from "rxjs";
import { MessageType } from "@core/enums/MessageType.enum";

export const stateInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
  const spinnerService = inject(SpinnerService);
  const messageService = inject(MessageService);
  const role = localStorage.getItem('role');
  spinnerService.setLoading(true);

  return next(req).pipe(
    catchError((error : HttpErrorResponse) => {
      messageService.loadMessage(
        error.status === 401 && role === 'User'
          ? 'Session expired. Please log in.' 
          : 'An error occurred.', 
          MessageType.ERROR
      );
      return throwError(()=> error);
    }),
    finalize(() => {
      spinnerService.setLoading(false);
    })
  );
};
